import {Component, Inject, OnInit} from '@angular/core';
import {MAT_DIALOG_DATA} from '@angular/material/dialog';
import {UploadDialogData} from '../upload/upload.component';

@Component({
  selector: 'app-upload-dialog',
  templateUrl: './upload-dialog.component.html',
  styleUrls: ['./upload-dialog.component.scss']
})
export class UploadDialogComponent implements OnInit {

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: UploadDialogData) {
  }

  ngOnInit() {
  }

}
